import React, { useEffect, useState } from 'react';
import { getOptionLabel, useNotification } from 'utils/commonUtils';
import { getSearchedStudents } from 'layouts/students/service/studentsApi';
import { FormInputAutoCompleteSearch } from 'components/Common/Forms/FormAutoCompleteSearch';

const DEBOUNCE_DELAY = 500;
const MIN_SEARCH_LENGTH = 1;

const StudentSearch = ({
  value,
  onSelect,
  disabled = false,
  placeholder = 'Enter name or ID...',
  label = 'Search for student by name or ID',
}) => {
  const { handleErrorResponse } = useNotification();

  const [studentOptions, setStudentOptions] = useState([]);
  const [studentSearchQuery, setStudentSearchQuery] = useState('');
  const [isStudentSearchLoading, setIsStudentSearchLoading] = useState(false);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (studentSearchQuery?.length >= MIN_SEARCH_LENGTH) {
        fetchSearchedStudents();
      } else {
        setStudentOptions([]);
      }
    }, DEBOUNCE_DELAY);

    return () => clearTimeout(handler);
  }, [studentSearchQuery]);

  const fetchSearchedStudents = async () => {
    try {
      setIsStudentSearchLoading(true);

      const searchedStudents = await getSearchedStudents(
        studentSearchQuery,
        true,
        false,
        20,
      );

      setStudentOptions(searchedStudents?.items || []);
      setIsStudentSearchLoading(false);
    } catch (error) {
      setIsStudentSearchLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  return (
    <FormInputAutoCompleteSearch
      label={label}
      value={value}
      disabled={disabled}
      options={studentOptions}
      placeholder={placeholder}
      setSelectedInput={onSelect}
      getOptionLabel={getOptionLabel}
      isSearchloading={isStudentSearchLoading}
      setInputSearchQuery={setStudentSearchQuery}
    />
  );
};

export default StudentSearch;
